exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my-label-text-size .v-label{font-size:14px!important}", "", {"version":3,"sources":["/app/src/components/PpmPlanner.vue"],"names":[],"mappings":"AACA,6BACE,wBAA2B,CAC5B","file":"PpmPlanner.vue","sourcesContent":["\n.my-label-text-size .v-label {\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":{"safe":true,"reduceIdents":false,"zindex":false,"mergeRules":false,"discardComments":{"removeAll":true}},"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c4e39e7","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/PpmPlanner.vue
// module id = 877
// module chunks = 2